/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import React, {useRef, useEffect} from "react";
import {useGLTF, useAnimations} from "@react-three/drei";

export default function Model({...props}) {
  const group = useRef();
  const {nodes, materials, animations} = useGLTF(
    "/Treadmill/millRunningBelt.glb"
  );
  const {actions} = useAnimations(animations, group);
  useEffect(() => {
    actions.Animation10.play();
    actions.Animation10.repetitions = 1;
    actions.Animation10.clampWhenFinished = true;
  }, [actions]);
  return (
    <group ref={group} {...props} dispose={null}>
      <group>
        <group name="runningBelt">
          <mesh
            geometry={nodes.圓柱體001.geometry}
            material={materials["材質.005"]}
          />
          <mesh
            geometry={nodes.圓柱體001_1.geometry}
            material={materials.跑帶}
          />
        </group>
      </group>
    </group>
  );
}

useGLTF.preload("/Treadmill/millRunningBelt.glb");
